import Vue from "vue"
import HighchartsVue from "highcharts-vue"
import Highcharts from "highcharts"
import HistogramBellcurve from "highcharts/modules/histogram-bellcurve"
HistogramBellcurve(Highcharts)
import HighchartsMore from "highcharts/highcharts-more"
HighchartsMore(Highcharts)
import AnnotationsFactory from "highcharts/modules/annotations"
AnnotationsFactory(Highcharts)
import _ from "lodash"

Vue.use(HighchartsVue, { tagName: "Charts" })

Highcharts.theme = {
  chart: { backgroundColor: "transparent" },
}
Highcharts.setOptions(Highcharts.theme)

import Network from "@/../node_modules/vue2vis/src/components/Network"
Vue.component("Network", Network)

const methods = {
  chartBaseParams() {
    return {
      credits: { enabled: false },
      exporting: { enabled: false },
      plotOptions: {
        series: {
          turboThreshold: 0,
          events: {
            legendItemClick() {
              if (_.every(this.chart.series, { visible: true })) {
                _.each(this.chart.series, (s) => s.hide())
              }
            },
          },
        },
      },
      title: { text: undefined },
      tooltip: { enabled: false },
      xAxis: { title: false },
      yAxis: { title: false },
    }
  },
  reflowChart() {
    this.$nextTick().then(() => {
      if (this.$refs.chart) {
        this.$refs.chart.chart.reflow()
      }
    })
  },
}
Vue.mixin({ methods })
